import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './examples.styles'
import ExamplesSection from './examples-section/examples-section.container'
import ExamplesTable from './examples-table/examples-table.container'
import Spinner from 'pobble-components/dist/spinner'
import octopus from './octopus.png'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import FormLabel from 'pobble-components/dist/form-elements/form-label'

class Examples extends Component {
  componentDidMount() {
    this.props.onMount()
  }
  render() {
    const {
      classes,
      pending,
      noExamples,
      schoolOrganisationFilter,
      schoolIsPartOfOrganisation
    } = this.props
    return noExamples ? (
      <div>
        <img src={octopus} className={classes.illustration} alt="Not Found" />
        <p className={classes.container}>There are no examples yet.</p>
      </div>
    ) : pending ? (
      <Spinner />
    ) : (
      <>
        <div className={classes.intro}>
          <h5>Using these curated writing examples</h5>
          <p>
            You may wish to use these materials to help gain an understanding of
            age-appropriate expectations for each year group across the Primary
            phase (based on the National Curriculum for England). As these
            materials are simply a guide, we encourage all teachers to assess
            pupils according to your own school's assessment policy. You can
            also copy files and use these as neutral evidence collections in
            your own moderation and training sessions.
          </p>
          <p>
            The files marked STA are exemplification materials used in England
            for the end of KS1 and 2 or are writing samples from STA training
            collections.
          </p>
        </div>
        {schoolIsPartOfOrganisation && (
          <div className={classes.filter}>
            <FormLabel className={classes.label}>Filter:</FormLabel>
            <FormSelect
              value={schoolOrganisationFilter ? 'schoolOrganisation' : 'all'}
              onChange={e =>
                this.props.onSelect(e.target.value, schoolOrganisationFilter)
              }>
              <option value="all">All</option>
              <option value="schoolOrganisation">My local authority</option>
            </FormSelect>
          </div>
        )}
        {!schoolOrganisationFilter && (
          <div>
            <div>
              <h2>Free to view Writing Samples</h2>
              <ExamplesSection premium={false} />
            </div>
            <div>
              <h2>Premium Writing Samples</h2>
              <ExamplesSection premium={true} />
            </div>
          </div>
        )}
        {schoolOrganisationFilter && <ExamplesTable />}
      </>
    )
  }
}

export default injectSheet(styles)(Examples)
